exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile .auth-input label {\n  background-color: #fff;\n}\n", ""]);

// exports
